var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBusinessAndFinanceImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_458_5820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.85043 7.96236C2.67976 7.96236 2.50909 7.89703 2.37909 7.76703C2.11843 7.50636 2.11843 7.08503 2.37909 6.82436L6.98309 2.22036C7.24376 1.9597 7.66509 1.9597 7.92576 2.22036C8.18643 2.48103 8.18643 2.90236 7.92576 3.16303L3.32176 7.76703C3.19176 7.89703 3.02109 7.96236 2.85043 7.96236Z",
    fill: "#7B7B7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.35292 4.62903C8.22292 4.62903 8.09492 4.57836 7.99958 4.48236L5.66625 2.14903C5.52292 2.00636 5.48025 1.79103 5.55758 1.60436C5.63492 1.41769 5.81758 1.29569 6.01958 1.29569H8.35292C8.62892 1.29569 8.85292 1.51969 8.85292 1.79569V4.12903C8.85292 4.33103 8.73092 4.51369 8.54425 4.59103C8.48225 4.61636 8.41758 4.62903 8.35292 4.62903Z",
    fill: "#7B7B7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.51953 10.7957V14.629H1.51953V10.7957C1.51953 10.3357 1.89286 9.96236 2.35286 9.96236H4.6862C5.1462 9.96236 5.51953 10.3357 5.51953 10.7957Z",
    fill: "#7B7B7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8516 8.12903V14.629H6.85156V8.12903C6.85156 7.66903 7.2249 7.29569 7.6849 7.29569H10.0182C10.4782 7.29569 10.8516 7.66903 10.8516 8.12903Z",
    fill: "#7B7B7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1836 5.46236V14.629H12.1836V5.46236C12.1836 5.00236 12.5569 4.62903 13.0169 4.62903H15.3503C15.8103 4.62903 16.1836 5.00236 16.1836 5.46236Z",
    fill: "#7B7B7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3516 16.629H1.35156C1.07556 16.629 0.851562 16.405 0.851562 16.129C0.851562 15.853 1.07556 15.629 1.35156 15.629H16.3516C16.6276 15.629 16.8516 15.853 16.8516 16.129C16.8516 16.405 16.6276 16.629 16.3516 16.629Z",
    fill: "#7B7B7B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_458_5820"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.851562 0.629028)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessAndFinanceImage);
export default __webpack_public_path__ + "static/media/business_and_finance_image.cca917b610bb5ae9266e42c36a29597c.svg";
export { ForwardRef as ReactComponent };